document.documentElement.classList.remove('no-js');

const initializeSite = () => {
  const drawer = document.querySelector('[data-mobile-drawer]');
  const toggles = document.querySelectorAll('[data-menu-toggle]');
  const backdrop = document.querySelector('[data-menu-backdrop]');

  const setMenu = (open) => {
    if (!drawer) return;
    drawer.inert = !open;
    drawer.classList.toggle('is-open', open);
    drawer.setAttribute('aria-hidden', open ? 'false' : 'true');
    document.body.classList.toggle('menu-open', open);
    toggles.forEach((button) => button.setAttribute('aria-expanded', open ? 'true' : 'false'));
  };

  if(drawer) drawer.inert=true;
  toggles.forEach((button) => {
    button.addEventListener('click', () => {
      const open = !drawer?.classList.contains('is-open');
      setMenu(open);
    });
  });

  if (backdrop) {
    backdrop.addEventListener('click', () => setMenu(false));
  }

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') setMenu(false);
  });

  document.querySelectorAll('[data-sort-by]').forEach((select) => {
    select.addEventListener('change', (event) => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', event.target.value);
      window.location.href = url.toString();
    });
  });
};
if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',initializeSite,{once:true}); else initializeSite();

(() => {
 const init=()=>{
  const featured=()=>{document.querySelectorAll('[data-featured-limit],[data-related-parts]').forEach(root=>{const limit=Number(root.dataset.featuredLimit || 4); let n=0; root.querySelectorAll('[data-fitment-product-card]').forEach(card=>{const ok=card.dataset.fitmentStatus!=='incompatible' && n<limit;card.hidden=!ok;if(ok)n++;}); root.dataset.featuredReady='true';if(root.hasAttribute('data-related-parts'))root.closest('.related-parts').hidden=n===0;const empty=root.querySelector('[data-featured-empty]');if(empty)empty.hidden=n>0;});};
  featured(); window.addEventListener('lst:cards-refreshed',featured); window.addEventListener('lst:vehicle-changed',()=>setTimeout(featured,0));
  const contactVehicle=document.querySelector('[data-contact-vehicle]');
  if(contactVehicle){const fillVehicle=()=>{const summary=document.querySelector('[data-vehicle-bar-summary]')?.textContent;if(summary && !summary.includes('Select your'))contactVehicle.value=summary;};fillVehicle();window.addEventListener('lst:cards-refreshed',fillVehicle);window.addEventListener('lst:vehicle-changed',()=>setTimeout(fillVehicle,0));}
  const part=document.querySelector('[data-contact-part]');if(part)part.value=new URL(location.href).searchParams.get('part') || new URL(location.href).searchParams.get('search') || '';
  document.querySelectorAll('[data-fitment-open]').forEach(button=>button.addEventListener('click',()=>{const drawer=document.querySelector('[data-mobile-drawer]');drawer?.classList.remove('is-open');drawer?.setAttribute('aria-hidden','true');if(drawer)drawer.inert=true;document.querySelectorAll('[data-menu-toggle]').forEach(b=>b.setAttribute('aria-expanded','false'));document.body.classList.remove('menu-open');}));
  document.querySelectorAll('details.department-menu').forEach(menu=>menu.addEventListener('keydown',e=>{if(e.key==='Escape'){menu.open=false;menu.querySelector('summary').focus();}}));
  document.addEventListener('click',e=>{document.querySelectorAll('details.department-menu[open]').forEach(menu=>{if(!menu.contains(e.target))menu.open=false;});});
  const variants=document.querySelector('.product-form select[name="id"]'); const price=document.querySelector('[data-product-price-display]');if(variants && price)variants.addEventListener('change',()=>{const text=variants.selectedOptions[0]?.textContent || ''; const match=text.match(/—\s*(.+?)(?:\s*—|$)/);if(match)price.textContent=match[1];});
 };
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});else init();
})();

// Clear, nonredundant account navigation and query context.
document.querySelectorAll('.header-action').forEach(a=>{if(a.textContent.trim()==='Orders' && a.getAttribute('href')==='/account')a.remove();});
